import React from 'react';
import ReactDOM from 'react-dom/client';
import PeriodicFrequencies from './PeriodicFrequencies';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-periodic-frequencies',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<PeriodicFrequencies />
		</React.StrictMode>
	);
}
